import { get } from 'lodash'
import { useSelector } from 'react-redux'

export const getSavedLocation = () => {
  const L = sessionStorage.getItem('location')
  return JSON.parse(L)
}

// export const persistLocation = (location) => {
//   sessionStorage.setItem('location', JSON.stringify(location))
// }

export const persistLocation = (location) => {
  const size = new Blob([JSON.stringify(location)]).size / 1024; // Size in KB
  if (size > 5000) {  // Limit to ~5MB
    console.warn("Location data is too large to store!");
    return;
  }
  sessionStorage.setItem('location', JSON.stringify(location));
}


export const getBrowserPosition = async () => {
  const pos = await new Promise((resolve, reject) => {
    navigator.geolocation.getCurrentPosition(resolve, reject, { enableHighAccuracy: false, timeout: 1_000 });
  });

  return {
    latitude: pos.coords.latitude,
    longitude: pos.coords.longitude,
  };
}

export const useLocation = () => {
  return useSelector(state => get(state, 'user.location'))
}

// Default San Francisco location when permission is denied
export const getSFDefaultLocation = () => ({
  latitude: '37.7749',
  longitude: '-122.4194',
  city: 'San Francisco',
  region_name: 'California',
  region_code: 'CA',
  country_name: 'United States',
  country_code: 'US',
  continent_name: 'North America',
  zip: '94102'
})


// Preference to use browser location instead of ipstack
const USE_BROWSER_LOCATION_KEY = 'use_browser_location'

export const setUseBrowserLocation = (value) => {
  localStorage.setItem(USE_BROWSER_LOCATION_KEY, value ? 'true' : 'false')
}

export const getUseBrowserLocation = () => {
  const value = localStorage.getItem(USE_BROWSER_LOCATION_KEY)
  return value === 'true'
}

/** Haversine distance in miles between two lat/lng points  */
const MILE_TO_METER = 1609.34
const EARTH_RADIUS_METERS = 6378137

export const haversineDistanceMiles = (lat1, lng1, lat2, lng2) => {
  const rad = (d) => (d * Math.PI) / 180
  const dLat = rad(lat2 - lat1)
  const dLng = rad(lng2 - lng1)
  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(rad(lat1)) * Math.cos(rad(lat2)) * Math.sin(dLng / 2) ** 2
  const c = 2 * Math.asin(Math.sqrt(a))
  const meters = EARTH_RADIUS_METERS * c
  return meters / MILE_TO_METER
}
